/** Returns the modal scale for the supplied number of open layers above. */
export const getModalScale = (layersAbove: number): number => Math.max(0.9, 1 - 0.02 * layersAbove);

/** Scales shadow magnitudes by height before restoring their signs. */
const scaleShadowDimension = (dimension: number, height: number): number => {
    const scaledMagnitude = Math.round(Math.abs(dimension) * height);
    return dimension < 0 ? -scaledMagnitude : scaledMagnitude;
};

/** Builds the theme-aware shadow for the supplied number of open layers above. */
export const getModalShadow = (layersAbove: number): string => {
    if (layersAbove === 0) return 'var(--shadow-xl)';

    const height = layersAbove <= 2 ? 1 - layersAbove / 3 : (1 / 3) * 2 ** -(layersAbove - 2);
    const alphaMultiplier = 0.88 * (1 + 0.75 * (1 - height));
    const firstGeometry = [8, 18, -6].map((dimension) => scaleShadowDimension(dimension, height));
    const secondGeometry = [12, 42, -4].map((dimension) => scaleShadowDimension(dimension, height));
    const firstShadow = `0 ${firstGeometry[0]}px ${firstGeometry[1]}px ${firstGeometry[2]}px rgb(from var(--color-shadow-xl-01) r g b / calc(alpha * ${alphaMultiplier}))`;
    const secondShadow = `0 ${secondGeometry[0]}px ${secondGeometry[1]}px ${secondGeometry[2]}px rgb(from var(--color-shadow-xl-02) r g b / calc(alpha * ${alphaMultiplier}))`;

    return `${firstShadow}, ${secondShadow}`;
};
